import { useContext } from "react"
import { Button, Modal } from "components"
import { FormSection } from "./FormSection"
import * as yup from "yup"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import { random } from "uniqolor"
import type { DataList } from "../types"
import { useApi } from "utils"
import { Render } from "../utils"

export function CreateModal(props: {
  location_name?: string
  address?: string
  description?: string,
  country_id?: string,
  province_id?: string,
  regency_id?: string,
  subdistrict_id?: string,
  village_id?: string,
  onSuccess?: () => void
  toggle: () => void
  refetch?: () => void
}) {
  // Hooks
  const api = useApi()
  const { toggle } = useContext(Render)

  type CreateData = Omit<DataList, "location_id" | "country_name" | "province_name" | "regency_name" | "subdistrict_name" | "village_name"> 

  const defaultValues= {
    location_name: "",
    address: "",
    description: "",
    country_id: Number(props.country_id) ?? null,
    province_id: Number(props.province_id) ?? null,
    regency_id: Number(props.regency_id) ?? null,
    subdistrict_id: Number(props.subdistrict_id) ?? null,
    village_id: Number(props.village_id) ?? null,
    color: random().color,
  }
  const validationSchema = yup.object().shape({ location_name: yup.string().label("Location name").required() })
  const onSubmit = (value: CreateData) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post("/location/add", value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      ).then(() => {
        props.toggle()
        toggle()
        props?.refetch && props.refetch()
        if (props.onSuccess) {
          props.onSuccess()
        }
      }).catch(() => {}).finally(resolve)
    })
  }
  const methods = useForm<CreateData>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })

  return (
    <Modal isOpen title="SETUP | LOCATION" size="xl" closeModal={props.toggle}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormSection />

          <Modal.Footer className="text-end">
            <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>SAVE</Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  )
}